export const TATTOOS = ['Visible', 'Not Visible', 'None'];
